import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.user.profile;
//VERIFY IF THE JWT IS SET
const showNewAccountCreatedModal = createSelector(
  getData,
  profile =>
    isEmpty(profile) ? false : profile.isFemale === null ? true : false
);
export default showNewAccountCreatedModal;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/showNewAccountCreatedModal.js